export default class SourceValue {
    constructor(source = {}, value = {}, optional = true) {
        this.source = source;
        this.value = value;
        this.optional = optional;
    }
}